










































































import * as Vue from '@vue/composition-api'
export default Vue.createComponent({
  name: 'IconButton',
  props: {
    iconName: {
      type: String,
      default: ''
    },
    iconImage: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: ''
    }
  }
})
